
import { defineComponent, onMounted, ref } from 'vue';
import anime from 'animejs';

export default defineComponent({
  name: 'ProgressBar',
  setup() {
    const progressBarFill = ref();
    const progressTooltip = ref();
    const progressFill = ref();
    onMounted(() => {
      const progressBarAnimation = () => {
        const randomWidth = anime.random(0, 96);
        anime({
          targets: progressBarFill.value,
          width: `${randomWidth}%`,
          easing: 'easeOutExpo',
          duration: 3000,
          complete: progressBarAnimation
        });
        anime({
          targets: progressTooltip.value,
          left: `calc(${randomWidth}% - 3rem)`,
          easing: 'easeOutExpo',
          duration: 3000,
          update: () => {
            progressFill.value = Math.round((randomWidth / 96) * 100);
          }
        });
      };
      progressBarAnimation();
    });

    return {
      progressBarFill,
      progressTooltip,
      progressFill
    };
  }
});
